import React, { Suspense } from 'react';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import { CircularProgress } from '@material-ui/core';

import { ActiveRecruitmentGenericPage } from './components/pages/recruitment/ActiveRecruitmentGenericPage';
import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { UserRegistration } from "./components/user-profile/UserRegistration";
import { UserLogIn } from "./components/user-profile/UserLogIn";
import { UserConfirmationMail } from "./components/user-profile/UserConfirmationMail";
import { ProfileDesign } from "./components/user-profile/ProfileDesign";
import { ProfileDesignPreview } from "./components/user-profile/ProfileDesignPreview";
import { ProfileSettings } from "./components/user-profile/ProfileSettings";
import { ChangePassword } from "./components/user-profile/ChangePassword";
import KamRecruitmentHomepage from "./components/pages/recruitment/KamRecruitmentHomepage";

function App() {
    return (
      <>
          <Router>
              <Suspense
                fallback={
                    <div className="centered">
                        <CircularProgress />
                    </div>
                }
              >
                  <ErrorBoundary>
                      <Switch>
                          <Route path="/" exact>
                              {/*<Redirect to="/career_opportunities/published" />*/}
                              <KamRecruitmentHomepage />
                          </Route>
                          <Route path="/career_opportunities/published" exact>
                              <KamRecruitmentHomepage />
                          </Route>
                          <Route path="/career_opportunities/details/:id" exact>
                              <ActiveRecruitmentGenericPage />
                          </Route>
                          <Route path="/career_opportunities/registration" exact>
                              <UserRegistration />
                          </Route>
                          <Route path="/career_opportunities/login" exact>
                              <UserLogIn />
                          </Route>
                          <Route path="/confirmation_mail/:code" exact>
                              <UserConfirmationMail />
                          </Route>
                          <Route path="/career_opportunities/profile" exact>
                              <ProfileDesign />
                          </Route>
                          <Route path="/career_opportunities/profile_preview" exact>
                              <ProfileDesignPreview />
                          </Route>
                          <Route path="/career_opportunities/profile_settings" exact>
                              <ProfileSettings />
                          </Route>
                          <Route path="/career_opportunities/change_password" exact>
                              <ChangePassword />
                          </Route>
                      </Switch>
                  </ErrorBoundary>
              </Suspense>
          </Router>
      </>
    );
}

export default App;
